let domen = 'genom.kcsni-service.ru';

let https = 'https';
if (process.env.NODE_ENV === 'development') {
  domen = '127.0.0.1:8001';
  https = 'http';
}

export const DOMEN = `${https}://${domen}`;
export const AUTH_URL = `${https}://${domen}/accounts/`;
export const USER_URL = `${https}://${domen}/api/users/`;
export const REFERENCES_URL = `${https}://${domen}/api/references/`;
export const PROPOSAL_URL = `${https}://${domen}/api/proposals/`;
export const EQUIMENT_URL = `${https}://${domen}/api/references/equipment/list/`;
export const METHOD_URL = `${https}://${domen}/api/references/method/list/`;
export const INDIVIDUAL_URL = `${https}://${domen}/api/users/individual/list/?last_name`;
export const SCIENTIFIC_AREA_URL = `${https}://${domen}/api/references/scientific-area/list/`;
export const PROPOSAL_DETAIL_URL = `${https}://${domen}/api/proposals/proposal/detail/`;
export const PROPOSAL_PERMISSIONS_URL = `${https}://${domen}/api/proposals/proposal/permissions/`;
export const FILE_POST_URL = `${https}://${domen}/api/references/file/detail/`;
export const REQUEST_URL = `${https}://${domen}/api/proposals/proposal/status/`;
export const STATUS_URL = `${https}://${domen}/api/proposals/proposal/list/`;
export const EXPERT_URL = `${https}://${domen}/api/users/individual/list/?role=expert`;
export const PDF_URL = `${https}://${domen}/api/proposals/proposal/export/`;
export const EXPORT_LIST_TO_EXCEL_URL = `${https}://${domen}/api/proposals/proposal/export_list_excel/`;
export const EXPORT_LIST_TO_DOCX_URL = `${https}://${domen}/api/proposals/proposal/export_list_word/`;
export const ADD_COMMENT_BS_URL = `${https}://${domen}/api/proposals/comment/detail/`;
export const ADD_EXPERIMENT_BS_URL = `${https}://${domen}/api/schedules/experiment/detail/`;
export const ADD_BS_REPORT_URL = `${https}://${domen}/api/proposals/bs-report/list/`;

export const LANGUAGE_URL = `${https}://${domen}/api/users/profile/detail/`;
export const USER_LIST_URL = `${https}://${domen}/api/users/individual/list/?role=user`;
export const GET_USER_ID_URL = `${https}://${domen}/api/users/individual/detail/`;
export const SEARCH_MODERATOR_REQUEST_URL = `${https}://${domen}/api/proposals/proposal/search/`;


// Статика
export const GET_LIST_STATUS_URL = `${https}://${domen}/api/stats/proposals/status/`;
export const GET_LIST_STATUS_STATION_URL = `${https}://${domen}/api/stats/proposals/station/`;

export const GET_ALL_LIST_REQUEST_URL = `${https}://${domen}/api/stats/proposals/total/`;
export const GET_LIST_USERS_URL = `${https}://${domen}/api/stats/users/total/`;
export const GET_LIST_USER_ROLE_URL = `${https}://${domen}/api/stats/users/role/`;

export const GET_GENERAL_STATUS_URL = `${https}://${domen}/api/stats/general/`;

export const GET_LIST_REQUEST_CREATED_URL = `${https}://${domen}/api/stats/proposals/weekly/?status=created`;
export const GET_LIST_REQUEST_DONE_URL = `${https}://${domen}/api/stats/proposals/weekly/?status=done`;

// help
export const GET_MD_URL = `${https}://${domen}/api/references/help/detail/`;


export const GET_LIST_USER_MEETING_URL = `${https}://${domen}/api/users/user_meeting/list/`;
export const GET_USER_MEETING_REG_URL = `${https}://${domen}/api/users/user_meeting_reg/list/`;
export const MAKE_REGISTRATION_URL = `${https}://${domen}/api/users/registration/make/`;
export const ADD_THESIS_FILE_URL = `${https}://${domen}/api/users/registration/add_file/`;
export const EXPORT_USER_LIST_TO_EXCEL_URL = `${https}://${domen}/api/users/export/excel/`;
export const CHANGE_REGISTRATION_URL = `${https}://${domen}/api/users/registration/change/`;
export const MAKE_INVITE_URL = `${https}://${domen}/api/users/registration/invite/`;
export const MAKE_SERT_URL = `${https}://${domen}/api/users/registration/sert/`;

export const USERMEETING_DETAIL_URL = `${https}://${domen}/api/users/user_meeting/get/`;
export const CHANGE_USERMEETING_URL = `${https}://${domen}/api/users/user_meeting/change/`;
export const GET_SECTIONS_URL = `${https}://${domen}/api/users/user_meeting/sections/`;
export const UPLOAD_THESIS_URL = `${https}://${domen}/api/users/user_thesis/upload/`;
export const DELETE_THESIS_URL = `${https}://${domen}/api/users/user_thesis/delete/`;
export const LOAD_THESIS_REC_URL = `${https}://${domen}/api/users/user_thesis/load/`;
export const THESIS_EXPORT_TO_DOCX_URL = `${https}://${domen}/api/users/user_thesis/to_doc/`;

